import { render, staticRenderFns } from "./scores.vue?vue&type=template&id=33d9205b"
import script from "./scores.vue?vue&type=script&lang=js"
export * from "./scores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports